import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Sidebar from '../Sidebar/Sidebar';
import Dashboard from '../Dashborad/Dashboard';
import ProfilePage from '../Profile/ProfilePage';
import ClientPage from '../Client/ClientPage';
import ClientDetailPage from '../client_details/ClientDetailPage';
import Chats from '../chat/Chats';
import PlansPage from '../Plans/PlansPage';
import { ChatProvider } from '../../context/ChatContext/chatContext';
import '../styles/customScrollbar.css';
import MealPlanDetailsPage from '../Plans/Meal_Creation/Meal_Plan_Details_page/MealPlanDetailsPage';
import MealPlanCreatePage from '../Plans/Meal_Creation/MealPlanCreatePage';
import useCustomScrollbar from '../styles/useCustomScrollbar';
import RecipeDetailPage from '../client_details/component/Recipe_Tab/RecipeTab_Component/Recipedetailpage';
import SalesPage from '../Sales/SalesPage';
import SalesClientPage from '../Sales_Client/sales_client';
import SalesClientDetailPage from '../Sales_Client/SalesClientDetailPage';
import GlobalTemplatePage from '../GlobalTemplate/GlobalTemplatePage';
import TeamPage from '../Team/TeamPage';
import AddNutritionistPage from '../Team/AddNutritionist/AddNutritionistPage';
import NutritionistViewPage from '../Team/ViewNutritionist/NutritionistViewPage';
import RolesAccessPage from '../Team/RolesAccess/RolesAccessPage';
import IngredientPage from '../Food_Library/Ingredient/IngredientPage';
import AddIngredientPage from '../Food_Library/Ingredient/AddIngredient/AddIngredientPage';
import ViewIngredientPage from '../Food_Library/Ingredient/ViewIngredient/ViewIngredientPage';
import DishPage from '../Food_Library/Dish/DishPage';
import AddDishPage from '../Food_Library/Dish/AddDish/AddDishPage';
import ViewDishPage from '../Food_Library/Dish/ViewDish/ViewDishPage';
import AdhocMealPage from '../AdhocMeal/AdhocMealPage';
import PermissionRoute from '../Auth/PermissionRoute';

const Layout: React.FC = () => {
  useCustomScrollbar();

  return (
    <ChatProvider>
      <div className="flex h-screen overflow-hidden bg-[#F7F7FA]">
        <Sidebar />
        <div className="flex-1 overflow-y-auto relative custom-scrollbar-overlay ">
          <Routes>
            <Route path="/"                                   element={<Dashboard />} />
            <Route path="/dashboard"                          element={<Dashboard />} />
            <Route path="/profile"                            element={<ProfilePage />} />

            {/* My Client (top-level nutritionist view of assigned clients) */}
            <Route path="/client"                             element={<ClientPage />} />
            <Route path="/client/:userId"                     element={<ClientDetailPage />} />
            <Route path="/client/:userId/plans"               element={<PlansPage />} />
            <Route path="/client/:userId/plans/meal/create"   element={<PermissionRoute resource="meal_plan" action="create"><MealPlanCreatePage /></PermissionRoute>} />
            <Route path="/client/:userId/plans/meal/:planId"  element={<PermissionRoute resource="meal_plan" action="view"><MealPlanDetailsPage /></PermissionRoute>} />
            {/* ── Standalone recipe detail page (recipe_library not yet gated) ── */}
            <Route path="/client/:userId/recipe/:recipeId"    element={<RecipeDetailPage />} />

            <Route path="/chat"                               element={<PermissionRoute resource="chat" action="access_chat"><Chats /></PermissionRoute>} />

            {/* Food Library (Dish + Ingredient) */}
            <Route path="/food-library"                       element={<Navigate to="/food-library/ingredient" replace />} />
            <Route path="/food-library/dish"                  element={<DishPage />} />
            <Route path="/food-library/dish/add"              element={<AddDishPage />} />
            <Route path="/food-library/dish/:id/edit"         element={<AddDishPage />} />
            <Route path="/food-library/dish/:id"              element={<ViewDishPage />} />
            <Route path="/food-library/ingredient"            element={<IngredientPage />} />
            <Route path="/food-library/ingredient/add"        element={<AddIngredientPage />} />
            <Route path="/food-library/ingredient/:id/edit"   element={<AddIngredientPage />} />
            <Route path="/food-library/ingredient/:id"        element={<ViewIngredientPage />} />

            {/* Adhoc meal plans */}
            <Route path="/adhoc-meal"                         element={<AdhocMealPage />} />
            <Route path="/adhoc-meal/create"                  element={<MealPlanCreatePage />} />
            <Route path="/adhoc-meal/:planId"                 element={<MealPlanDetailsPage />} />

            {/* Team / Admin */}
            <Route path="/team"                               element={<PermissionRoute resource="admin" action="manage_nutritionists"><TeamPage /></PermissionRoute>} />
            <Route path="/team/add-nutritionist"              element={<PermissionRoute resource="admin" action="manage_nutritionists"><AddNutritionistPage /></PermissionRoute>} />
            <Route path="/team/nutritionist/:id"              element={<PermissionRoute resource="admin" action="manage_nutritionists"><NutritionistViewPage /></PermissionRoute>} />
            <Route path="/team/roles-access"                  element={<PermissionRoute resource="admin" action="assign_roles"><RolesAccessPage /></PermissionRoute>} />

            {/* Sales module */}
            <Route path="/sales"                              element={<PermissionRoute resource="sales" action="view"><SalesPage /></PermissionRoute>} />
            <Route path="/sales-clients"                      element={<PermissionRoute resource="client" action="view_all"><SalesClientPage /></PermissionRoute>} />
            <Route path="/sales-clients/:userId"              element={<PermissionRoute resource="client" action="view_all"><SalesClientDetailPage /></PermissionRoute>} />

            {/* Global Templates */}
            <Route path="/global-template"                    element={<PermissionRoute resource="global_template" action="view"><GlobalTemplatePage /></PermissionRoute>} />
            <Route path="/global-template/create"             element={<PermissionRoute resource="global_template" action="create"><MealPlanCreatePage /></PermissionRoute>} />
            <Route path="/global-template/plan/:planId"       element={<PermissionRoute resource="global_template" action="view"><MealPlanDetailsPage /></PermissionRoute>} />
            <Route path="/global-template/suggestion/:planId" element={<PermissionRoute resource="global_template" action="view"><MealPlanDetailsPage /></PermissionRoute>} />
          </Routes>
        </div>
      </div>
    </ChatProvider>
  );
};

export default Layout;